<div class="document-buttons" [ngClass]="{ 'document-buttons-chico': document_buttons_chico }">
  <div id="btn-campaign" class="document-button" [ngClass]="activeForm == 'campaign' ? 'selected' : ''"
    (click)="emitchangeForm('campaign')">
    <button type="submit" class="btn-documents">
      <i class="icon-bullhorn"></i>
      {{ "forms.buttons.campaign" | translate }}
      <span *ngIf="updatesTabs.includes('campaign')" class="violet-dot"></span>
    </button>
  </div>
</div>
